export function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

export function isMobile() {
  if (typeof navigator === "undefined") return false;
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function detectDevice() {
  const ua = navigator.userAgent;

  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  if (/Xiaomi|Redmi|POCO|MiuiBrowser|Mi Browser/i.test(ua)) return "xiaomi";
  if (/SamsungBrowser/i.test(ua)) return "samsung";
  if (/Android/i.test(ua)) return "android";
  return "desktop";
}

export function getBrowserName() {
  const ua = navigator.userAgent;
  if (/MiuiBrowser|Mi Browser/i.test(ua)) return "mi-browser";
  if (/SamsungBrowser/i.test(ua)) return "samsung-browser";
  if (/EdgA/i.test(ua)) return "edge";
  if (/Chrome/i.test(ua) && !/Edg/i.test(ua)) return "chrome";
  if (/Firefox/i.test(ua)) return "firefox";
  return "other";
}

export function needsManualInstallGuide() {
  if (!isMobile() || isStandalone()) return false;
  const device = detectDevice();
  return device === "xiaomi" || device === "android";
}